module.exports = __webpack_public_path__ + "img/kernel.c55da1c7.png";